import React from 'react';
import './Modal.css';

const FieldCardModal = ({ card, onAction, onClose }) => {
  if (!card) return null;

  const isFaceDown = card.isFaceDown;
  const isMonster = card.type?.includes('Monster');
  const isXYZMonster = card.type?.includes('XYZ');
  const isSpellTrap = !isMonster;
  const isExtra = card.type?.match(/Fusion|Synchro|XYZ|Link/);
  const isToken = card.type?.includes('Token');

  let actions = [];
  if (card.zone?.startsWith('Opp')) {
  actions = []; // No actions for opponent card
}

    else if (isMonster && !isFaceDown) {
      if (isToken) {
        actions = [
          card.position === 'DEF' ? 'To ATK' : 'To DEF',
          'Remove'
        ];
      } else {
        actions = [
          'Move', 'Target',
          'To Bottom Deck',
          'To Top Deck',
          'Banish FD', 'Banish',
          isExtra ? 'To Extra' : 'To hand',
          'Set',
          card.position === 'DEF' ? 'To ATK' : 'To DEF',
          'Declare', 'To GY',
          'Xyz Material'
      
        ];

        // ✅ Only for Pendulum monsters
        if (card.type?.includes('Pendulum')) {
          actions.push('To Extra FaceUp');
        }
         if (card.type?.includes('XYZ')) {
          actions.push('Show Material');
        }
      }
    }
    


    else if (isMonster && isFaceDown) {
    actions = [
      'Move', 'Target',
      'To Bottom Deck',
      'To Top Deck',
      'Banish FD', 'Banish',
      isExtra ? 'To Extra' : 'To hand',
      'Flip', 'Flip Summon', 'To GY'
    ];
   
  } else if (isSpellTrap) {
    actions = [
      'Move', 'Target',
      'To Bottom Deck',
      'To Top Deck',
      'Banish FD', 'Banish',
      isExtra ? 'To Extra' : 'To hand',
      'Activate ST','To GY'
    ];
  }
    if (
    isXYZMonster &&
    !isFaceDown &&
    Array.isArray(card.overlays) &&
    card.overlays.length > 0
  ) {
    actions.push('Show Material'); // ✅ renamed to avoid conflict
  }


  return (
    <div className="modal-backdrop">
      <div className="modal-content hand-menu-modal">
        <div className="modal-left">
          <img
          onContextMenu={(e) => e.preventDefault()}
          onMouseDown={(e) => e.button === 2 && e.preventDefault()}
          onTouchStart={(e) => e.preventDefault()}
          draggable={false}
            src={card.card_images?.[0]?.image_url} // ✅ always real image
            alt={card.name}
            className="modal-card-image"
            />
          <div className="modal-card-info">
            <h3>{card.name}</h3>
            <p><strong>Card:</strong> {card.type}</p>
            {card.atk !== undefined && isMonster && (
              <p><strong>ATK/DEF:</strong> {card.atk} / {card.def ?? '—'}</p>
            )}
            {card.level && isMonster && <p><strong>Level:</strong> {card.level}</p>}
            {card.linkval && <p><strong>Link Rating:</strong> {card.linkval}</p>}
            {card.race && <p><strong>Type:</strong> {card.race}</p>}
            {card.attribute && <p><strong>Attribute:</strong> {card.attribute}</p>}
            <p dangerouslySetInnerHTML={{ __html: card.desc?.replace(/\n/g, '<br/>') }} />
          </div>
        </div>

        <div className="modal-right">
          <h3>Choose Action</h3>
          <ul className="action-list">
            {actions.map((action, index) => (
              <li key={index} onClick={() => onAction(action)}>{action}</li>
            ))}
          </ul>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default FieldCardModal;
